<template>
    <div class="page">
        <div class="container">
            <div class="breadcrumb">
                <span class="crumb" @click="$router.push('/dashboard')">Home</span>
                <i class="el-icon-arrow-right sep" />
                <span class="crumb" @click="$router.push('/proxies')">Proxies</span>
                <i class="el-icon-arrow-right sep" />
                <span class="crumb-current">Manage Proxies</span>
            </div>

            <div class="head">
                <div class="head-left">
                    <div class="title">Quản lý Proxy Admin</div>
                    <div class="sub">Tạo và quản lý các proxy cá nhân: cố định, xoay vòng ngẫu nhiên hoặc theo khu vực.
                    </div>
                </div>
                <div class="head-actions">
                    <el-button size="small" @click="onExport">
                        <i class="el-icon-download" />
                        <span>Export List</span>
                    </el-button>
                </div>
            </div>

            <div class="grid">
                <!-- Left: create form -->
                <div class="left">
                    <el-card class="card">
                        <div slot="header" class="card-header">Create New Proxy</div>

                        <el-form :model="form" label-position="top" class="form">
                            <el-form-item label="Proxy Label">
                                <el-input v-model="form.label" placeholder="e.g. My Marketing Proxy" clearable />
                            </el-form-item>

                            <!-- <el-form-item label="Connection Mode">
                <el-radio-group v-model="form.mode" class="mode-group">
                  <el-radio label="fixed" border class="mode-item">
                    <div class="mode-title">Fixed Device</div>
                    <div class="mode-sub">Assign to a specific device</div>
                  </el-radio>
                  <el-radio label="rotating_random" border class="mode-item">
                    <div class="mode-title">Rotating (Random)</div>
                    <div class="mode-sub">New IP on every connection</div>
                  </el-radio>
                  <el-radio label="rotating_geo" border class="mode-item">
                    <div class="mode-title">Rotating (Geo)</div>
                    <div class="mode-sub">Filter peers by region</div>
                  </el-radio>
                </el-radio-group>
              </el-form-item> -->

                            <div class="row-2">
                                <el-form-item label="Peer ID">
                                    <el-input v-model="form.provider_peer_id" placeholder="e.g. 4159b91c-..."
                                        clearable />
                                </el-form-item>
                                <el-form-item label="Country Code">
                                    <el-select v-model="form.country_code" placeholder="Select country..." filterable
                                        clearable class="w-full">
                                        <el-option v-for="c in countryOptions" :key="c.code"
                                            :label="c.name + ' (' + c.code + ')'" :value="c.code" />
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="row-2">
                                <el-form-item label="Username">
                                    <el-input v-model="form.username" />
                                </el-form-item>
                                <el-form-item label="Password">
                                    <el-input v-model="form.password" show-password />
                                </el-form-item>
                            </div>

                            <el-button type="primary" class="btn-full" :loading="creating" @click="onGenerate">Generate
                                Proxy</el-button>
                        </el-form>
                    </el-card>

                </div>

                <!-- Right: list -->
                <div class="right">
                    <div class="list-toolbar">
                        <el-input v-model="filters.keyword" size="small" clearable class="search"
                            placeholder="Search proxies..." prefix-icon="el-icon-search"
                            @keyup.enter.native="onApply" />

                        <el-select v-model="filters.mode" size="small" clearable class="mode-filter"
                            placeholder="All Modes" @change="onApply">
                            <el-option label="Fixed" value="fixed" />
                            <el-option label="Rotating (Random)" value="rotating_random" />
                            <el-option label="Rotating (Geo)" value="rotating_geo" />
                        </el-select>
                    </div>

                    <div class="table-card" style="margin-top: 12px;">
                        <el-table ref="table" v-loading="loading" :data="rows" :height="tableHeight" stripe
                            class="admin-proxy-table" style="width:100%">
                            <el-table-column label="ID" width="90">
                                <template slot-scope="scope">
                                    <div class="id-cell">
                                        <span class="mono">#{{ scope.row.code }}</span>

                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column label="Label & Auth" min-width="260">
                                <template slot-scope="scope">
                                    <div class="label-cell">
                                        <div class="label-title">{{ scope.row.label }}</div>
                                        <div class="label-sub mono">user: {{ scope.row.username }}</div>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column label="Mode" min-width="170">
                                <template slot-scope="scope">
                                    <div class="mode-cell">
                                        <i :class="modeIcon(scope.row.mode)" class="mode-ico" />
                                        <span class="mode-text">{{ modeText(scope.row.mode) }}</span>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column label="Target" min-width="200">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.targetLabel }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="Status" width="140" align="center">
                                <template slot-scope="scope">
                                    <span class="status-pill" :class="statusClass(scope.row.status)">
                                        <span class="dot" />
                                        {{ scope.row.status }}
                                    </span>
                                </template>
                            </el-table-column>


                        </el-table>

                        <div class="footer">
                            <div class="footer-left">
                                Showing <span class="footer-strong">{{ showingFrom }}</span> to
                                <span class="footer-strong">{{ showingTo }}</span>
                                of <span class="footer-strong">{{ total }}</span> results
                            </div>
                            <div class="footer-right">
                                <el-pagination :current-page="currentPage" :page-size="limit" :page-sizes="[10, 20, 50]"
                                    :total="total" layout="sizes, prev, pager, next" @size-change="onSizeChange"
                                    @current-change="onCurrentChange" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createUserProxy, getUserSessions } from '../../api/proxyAdmin'
import { COUNTRIES } from '../../constants/countries'

export default {
    name: 'ProxyAdminView',
    data() {
        return {
            tableHeight: 420,
            limit: 20,
            offset: 0,
            total: 0,
            loading: false,
            creating: false,
            filters: {
                keyword: '',
                mode: ''
            },
            form: {
                label: '',
                mode: 'fixed',
                provider_peer_id: '',
                country_code: '',
                username: 'admin_proxy_01',
                password: ''
            },
            countryOptions: COUNTRIES,
            rows: []
        }
    },
    computed: {
        currentPage() {
            return Math.floor((this.offset || 0) / (this.limit || 1)) + 1
        },
        showingFrom() {
            if (!this.total) return 0
            return this.offset + 1
        },
        showingTo() {
            return Math.min(this.offset + (this.rows ? this.rows.length : 0), this.total)
        }
    },
    mounted() {
        this.fetchRows()
        this.$nextTick(this.calcTableHeight)
        window.addEventListener('resize', this.calcTableHeight, false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calcTableHeight, false)
    },
    methods: {
        calcTableHeight() {
            try {
                const el = this.$refs.table && this.$refs.table.$el ? this.$refs.table.$el : null
                if (!el) return
                const rect = el.getBoundingClientRect()
                const footer = this.$el ? this.$el.querySelector('.footer') : null
                const footerH = footer ? footer.getBoundingClientRect().height : 0
                const paddingBottom = 24
                const h = Math.floor(window.innerHeight - rect.top - footerH - paddingBottom)
                this.tableHeight = Math.max(260, h)
            } catch (e) { }
        },
        onApply() {
            this.offset = 0
            this.fetchRows()
        },
        onSizeChange(size) {
            this.limit = size
            this.offset = 0
            this.fetchRows()
        },
        onCurrentChange(page) {
            const p = Number(page || 1)
            this.offset = Math.max(0, (p - 1) * this.limit)
            this.fetchRows()
        },
        async fetchRows() {
            this.loading = true
            try {
                const data = await getUserSessions({
                    limit: this.limit,
                    offset: this.offset,
                    keyword: this.filters.keyword || undefined
                })

                const sessions = (data && data.sessions) ? data.sessions : []
                this.rows = sessions.map(s => this.mapSessionRow(s))
                this.total = (data && typeof data.total === 'number') ? data.total : (this.offset + this.rows.length)
            } catch (e) {
                this.$message && this.$message.error('Không tải được user sessions')
            } finally {
                this.loading = false
                this.$nextTick(this.calcTableHeight)
            }
        },
        mapSessionRow(s) {
            const id = s && s.id ? String(s.id) : ''
            const short = id ? id.slice(0, 6).toUpperCase() : '--'
            const peer = s && s.provider_peer ? s.provider_peer : null
            const country = peer && peer.country_code ? peer.country_code : ''
            const ip = peer && peer.ip_address ? peer.ip_address : ''
            const targetLabel = [country, ip].filter(Boolean).join(' • ') || '—'
            const providerPeerId = s && s.provider_peer_id ? String(s.provider_peer_id) : (peer && peer.id ? String(peer.id) : '')

            const label = (s && s.label) ? String(s.label) : ((peer && peer.name) ? peer.name : '—')
            const username = (s && s.username) ? String(s.username) : ''
            const statusRaw = (s && s.status) ? String(s.status) : ''
            const status = statusRaw === 'active' ? 'Active' : (statusRaw === 'closed' ? 'Closed' : (statusRaw || '—'))

            return {
                id: id || short,
                code: short,
                label,
                username,
                mode: 'fixed',
                target: country,
                targetLabel,
                status,
                provider_peer_id: providerPeerId,
                _raw: s
            }
        },
        async copyText(text) {
            const t = String(text || '')
            if (!t) return
            try {
                if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(t)
                } else {
                    const el = document.createElement('textarea')
                    el.value = t
                    el.setAttribute('readonly', '')
                    el.style.position = 'absolute'
                    el.style.left = '-9999px'
                    document.body.appendChild(el)
                    el.select()
                    document.execCommand('copy')
                    document.body.removeChild(el)
                }
                this.$message && this.$message.success('Copied')
            } catch (e) {
                this.$message && this.$message.error('Copy failed')
            }
        },
        onExport() {
            this.$message && this.$message.info('Export (demo)')
        },
        onGenerate() {
            this.createProxy()
        },
        async createProxy() {
            if (this.creating) return

            const label = String(this.form.label || '').trim()
            const providerPeerId = String(this.form.provider_peer_id || '').trim()
            const countryCode = String(this.form.country_code || '').trim().toUpperCase()
            const username = String(this.form.username || '').trim()
            const password = String(this.form.password || '').trim()

            if (!label) return this.$message && this.$message.warning('Vui lòng nhập Proxy Label')
            if (!providerPeerId) return this.$message && this.$message.warning('Vui lòng nhập Peer ID')
            if (!countryCode) return this.$message && this.$message.warning('Vui lòng nhập Country Code (VD: VN)')
            if (!username) return this.$message && this.$message.warning('Vui lòng nhập Username')
            if (!password) return this.$message && this.$message.warning('Vui lòng nhập Password')

            this.creating = true
            try {
                const payload = {
                    country_code: countryCode,
                    label,
                    password,
                    provider_peer_id: providerPeerId,
                    username
                }
                await createUserProxy(payload)

                this.$message && this.$message.success('Đã tạo proxy')
                this.form.label = ''
                this.form.provider_peer_id = ''
                this.form.country_code = ''
                this.form.password = ''
                this.offset = 0
                this.fetchRows()
            } catch (e) {
                const msg = (e && e.response && e.response.data && (e.response.data.message || e.response.data.error)) || 'Tạo proxy thất bại'
                this.$message && this.$message.error(msg)
            } finally {
                this.creating = false
            }
        },
        onEdit(row) {
            this.$message && this.$message.info(`Edit ${row.code} (demo)`)
        },
        onDelete(row) {
            this.$confirm(`Xoá proxy ${row.code}?`, 'Xác nhận', { type: 'warning' })
                .then(() => {
                    this.rows = (this.rows || []).filter(r => r.id !== row.id)
                    this.$message && this.$message.success('Đã xoá (demo)')
                    if (this.offset >= this.total) this.offset = Math.max(0, this.total - this.limit)
                })
                .catch(() => { })
        },
        modeText(mode) {
            if (mode === 'fixed') return 'Fixed'
            if (mode === 'rotating_random') return 'Rotate (Rnd)'
            if (mode === 'rotating_geo') return 'Rotate (Geo)'
            return mode || '—'
        },
        modeIcon(mode) {
            if (mode === 'fixed') return 'el-icon-connection'
            if (mode === 'rotating_random') return 'el-icon-refresh'
            if (mode === 'rotating_geo') return 'el-icon-location-outline'
            return 'el-icon-more-outline'
        },
        statusClass(s) {
            if (s === 'Active') return 'is-active'
            if (s === 'Connecting') return 'is-connecting'
            return 'is-inactive'
        }
    }
}
</script>

<style scoped>
.page {
    padding: 16px;
}

.container {
    max-width: 1600px;
    margin: 0 auto;
}

.breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #92a4c9;
    margin-bottom: 14px;
}

.crumb {
    cursor: pointer;
    color: #92a4c9;
}

.crumb:hover {
    color: #135bec;
}

.crumb-current {
    color: #ffffff;
    font-weight: 800;
}

.sep {
    font-size: 12px;
    opacity: .85;
}

.head {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-end;
    margin-bottom: 14px;
}

.title {
    font-size: 28px;
    font-weight: 900;
    color: #fff;
}

.sub {
    margin-top: 6px;
    color: #92a4c9;
    max-width: 900px;
}

.head-actions {
    display: flex;
    gap: 10px;
}

.grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
}

@media (min-width: 1200px) {
    .grid {
        grid-template-columns: 420px 1fr;
        align-items: start;
    }
}

.card {
    border-radius: 12px;
    overflow: hidden;
}

.card-header {
    font-weight: 900;
}

.form {
    padding-top: 6px;
}

.row-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.btn-full {
    width: 100%;
    margin-top: 8px;
}

.w-full {
    width: 100%;
}

.mode-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}

.mode-item {
    width: 100%;
}

.mode-title {
    font-weight: 800;
}

.mode-sub {
    font-size: 12px;
    color: #92a4c9;
    margin-top: 2px;
}


.list-toolbar {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    background: #1a2235;
    border: 1px solid #232f48;
    border-radius: 12px;
    padding: 12px;
}

.search {
    min-width: 260px;
    flex: 1;
}

.mode-filter {
    min-width: 180px;
}

.table-card {
    background: #1a2235;
    border: 1px solid #232f48;
    border-radius: 12px;
    overflow: hidden;
}

.mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.id-cell {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.icon-btn {
    padding: 0 6px;
    color: #92a4c9;
}

.icon-btn:hover {
    color: #ffffff;
}

.label-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.label-title {
    font-weight: 900;
    color: #fff;
}

.label-sub {
    font-size: 12px;
    color: #92a4c9;
    background: rgba(148, 163, 184, 0.12);
    padding: 2px 6px;
    border-radius: 6px;
    width: fit-content;
}

.mode-cell {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.mode-ico {
    color: #135bec;
}

.mode-text {
    color: #fff;
    font-weight: 700;
}

.status-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    border-radius: 999px;
    font-weight: 800;
    font-size: 12px;
    border: 1px solid #232f48;
    background: rgba(148, 163, 184, 0.1);
    color: #cbd5e1;
}

.status-pill .dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #94a3b8;
}

.status-pill.is-active {
    background: rgba(34, 197, 94, 0.12);
    border-color: rgba(34, 197, 94, 0.25);
    color: #86efac;
}

.status-pill.is-active .dot {
    background: #22c55e;
}

.status-pill.is-connecting {
    background: rgba(245, 158, 11, 0.12);
    border-color: rgba(245, 158, 11, 0.25);
    color: #fcd34d;
}

.status-pill.is-connecting .dot {
    background: #f59e0b;
}

.actions {
    display: inline-flex;
    gap: 6px;
}

.act {
    color: #92a4c9;
}

.act:hover {
    color: #ffffff;
    background: #232f48;
}

.danger {
    color: #fca5a5;
}

.danger:hover {
    color: #ffffff;
    background: rgba(239, 68, 68, 0.2);
}

.footer {
    border-top: 1px solid #324467;
    background: #161e2c;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.footer-left {
    color: #92a4c9;
    font-size: 12px;
}

.footer-strong {
    color: #ffffff;
    font-weight: 800;
}

.footer-right /deep/ .el-pager li {
    background: transparent;
    color: #92a4c9;
}

.footer-right /deep/ .el-pager li.active {
    color: #ffffff;
    background: #135bec;
    border-radius: 8px;
}

.footer-right /deep/ .btn-prev,
.footer-right /deep/ .btn-next {
    background: #232f48;
    color: #ffffff;
    border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/proxyAdmin/index.vue